import { cn } from '@/lib/utils';

export type FeedCheckboxState = 'idle' | 'working' | 'done';

// The look of a to-do's box at rest and while the user works on it, while the design is chosen
type CheckboxStyle = 'outline' | 'dot' | 'tint';
const CHECKBOX_STYLE = 'outline' as CheckboxStyle;

// A card's box: a quiet grey square at rest, a blue one while the user works on it, and ticked once done
export const FeedCheckbox = ({
  state,
  ticked = false,
  className,
}: {
  state: FeedCheckboxState;
  // Drawn ticked for a moment as the user checks it, before the row leaves
  ticked?: boolean;
  className?: string;
}) => {
  const working = state === 'working';
  const showsTick = ticked || state === 'done';
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cn(
        'shrink-0 transition-colors duration-[120ms] motion-reduce:transition-none',
        working
          ? 'text-brand-cyan-cornflower-blue dark:text-brand-jordy-blue'
          : CHECKBOX_STYLE === 'tint'
            ? 'text-foreground-subtle'
            : 'text-foreground-muted',
        className
      )}
    >
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        rx="4"
        stroke="currentColor"
        strokeWidth="1.75"
        fill={working && CHECKBOX_STYLE === 'tint' ? 'currentColor' : 'none'}
        fillOpacity={working && CHECKBOX_STYLE === 'tint' ? 0.16 : undefined}
      />
      {working && !showsTick && CHECKBOX_STYLE === 'dot' ? (
        <circle cx="12" cy="12" r="3.25" fill="currentColor" />
      ) : null}
      {showsTick ? (
        <path
          d="M8 12.5l2.75 2.75L16 9.75"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
    </svg>
  );
};
